import { render } from "./DemandForm.vue?vue&type=template&id=b0436290"
import script from "./DemandForm.vue?vue&type=script&lang=ts"
export * from "./DemandForm.vue?vue&type=script&lang=ts"
script.render = render

export default script